import React from 'react';
import { Instagram, Phone, Mail, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="bg-otter-black py-24 text-otter-bone" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="grid gap-16 lg:grid-cols-2" data-id="element-104">
          {/* Left: Form */}
          <div data-id="element-105">
            <h2 className="mb-8 font-display text-5xl tracking-tighter sm:text-7xl" data-id="element-106">
              HIT US <span className="text-otter-cyan" data-id="element-107">UP</span>
            </h2>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-108">
              <div className="grid gap-6 md:grid-cols-2" data-id="element-109">
                <div className="space-y-2" data-id="element-110">
                  <label className="font-display text-lg tracking-wider" data-id="element-111">
                    NAME
                  </label>
                  <input type="text" className="w-full border-2 border-otter-bone/20 bg-otter-black p-4 font-body text-otter-bone focus:border-otter-cyan focus:outline-none" placeholder="John Doe" data-id="element-112" />
                </div>
                <div className="space-y-2" data-id="element-113">
                  <label className="font-display text-lg tracking-wider" data-id="element-114">
                    PHONE
                  </label>
                  <input type="tel" className="w-full border-2 border-otter-bone/20 bg-otter-black p-4 font-body text-otter-bone focus:border-otter-cyan focus:outline-none" placeholder="(555) 123-4567" data-id="element-115" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-116">
                <label className="font-display text-lg tracking-wider" data-id="element-117">
                  EMAIL
                </label>
                <input type="email" className="w-full border-2 border-otter-bone/20 bg-otter-black p-4 font-body text-otter-bone focus:border-otter-cyan focus:outline-none" placeholder="john@example.com" data-id="element-118" />
              </div>

              <div className="space-y-2" data-id="element-119">
                <label className="font-display text-lg tracking-wider" data-id="element-120">
                  SERVICE TYPE
                </label>
                <select className="w-full appearance-none border-2 border-otter-bone/20 bg-otter-black p-4 font-body text-otter-bone focus:border-otter-cyan focus:outline-none" data-id="element-121">
                  <option data-id="element-122">The Basic ($149)</option>
                  <option data-id="element-123">The Full Send ($249)</option>
                  <option data-id="element-124">Commercial Quote</option>
                  <option data-id="element-125">Just have a question</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-126">
                <label className="font-display text-lg tracking-wider" data-id="element-127">
                  NOTES / GRILL TYPE
                </label>
                <textarea rows={4} className="w-full border-2 border-otter-bone/20 bg-otter-black p-4 font-body text-otter-bone focus:border-otter-cyan focus:outline-none" placeholder="It's a 3-burner Weber, hasn't been cleaned since 2019..." data-id="element-128"></textarea>
              </div>

              <button type="submit" className="w-full border-4 border-otter-cyan bg-otter-cyan py-4 font-display text-3xl tracking-wider text-otter-black transition-colors hover:bg-transparent hover:text-otter-cyan" data-id="element-129">
                SEND IT
              </button>
            </form>
          </div>

          {/* Right: Info */}
          <div className="flex flex-col justify-center lg:pl-12" data-id="element-130">
            <div className="space-y-12" data-id="element-131">
              <div className="flex items-start gap-6" data-id="element-132">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center border-2 border-otter-cyan bg-otter-black text-otter-cyan" data-id="element-133">
                  <Phone size={32} data-id="element-134" />
                </div>
                <div data-id="element-135">
                  <h3 className="font-display text-2xl tracking-wider text-otter-bone/60" data-id="element-136">
                    CALL/TEXT
                  </h3>
                  <p className="mt-2 font-display text-4xl text-otter-bone" data-id="element-137">
                    (555) 987-6543
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-138">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center border-2 border-otter-cyan bg-otter-black text-otter-cyan" data-id="element-139">
                  <Instagram size={32} data-id="element-140" />
                </div>
                <div data-id="element-141">
                  <h3 className="font-display text-2xl tracking-wider text-otter-bone/60" data-id="element-142">
                    INSTAGRAM
                  </h3>
                  <a href="https://www.instagram.com/ottergrillcleaning/" target="_blank" rel="noreferrer" className="mt-2 block font-display text-4xl text-otter-cyan hover:underline" data-id="element-143">
                    @ottergrillcleaning
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-6" data-id="element-144">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center border-2 border-otter-cyan bg-otter-black text-otter-cyan" data-id="element-145">
                  <MapPin size={32} data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <h3 className="font-display text-2xl tracking-wider text-otter-bone/60" data-id="element-148">
                    SERVICE AREA
                  </h3>
                  <p className="mt-2 font-body text-xl font-bold text-otter-bone" data-id="element-149">
                    Greater Metro Area & Suburbs
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-16 border-t-2 border-otter-bone/20 pt-8" data-id="element-150">
              <img src="https://cdn.magicpatterns.com/uploads/4HX4fnnnRHUFQ1DwVQMuBe/37.png" alt="Otter Logo" className="h-32 w-32 rounded-full border-4 border-otter-cyan object-cover opacity-50 grayscale transition-all hover:opacity-100 hover:grayscale-0" data-id="element-151" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}